import React from "react";
import styles from "./index.module.scss";

const WinnerBar = ({ text = "Winner", rank, className }) => {
  const getWinnerClass = () => {
    switch (rank) {
      case "2":
        return styles.FirstWinnerBar;
      case "1":
        return styles.SecondWinnerBar;
      case "3":
        return `mt-4 ${styles.ThirdWinnerBar}`;
      default:
        return styles.DefaultWinnerBar;
    }
  };

  const getWinnerText = () => {
    switch (rank) {
      case "2":
        return "1";
      case "1":
        return "2";
      case "3":
        return "3";
    }
  };

  return <div className={`${getWinnerClass()} ${className}`}>{getWinnerText()}</div>;
};

export default WinnerBar;
